import React from 'react';
import { DateDisplay } from '../common/date-display/DateDisplay';
import { DateFormats } from '../common/enums/DateFormat';
import {CautionBadge, CriticalBadge, StandardBadge} from '../common/status-badge/StatusBadge';
export interface IChartExpiryBadgeProps {
    isReviewSoon: boolean |null |undefined,
    isReviewDue: boolean | undefined,
    expiryDate: string | null | undefined
}

export const ChartExpiryBadge = (props: IChartExpiryBadgeProps) => {

    if (props.expiryDate==null){
        return null;
    }
    
    if (props.isReviewDue) {
        return (
            <CriticalBadge><ChartExpiryText expiryDate={props.expiryDate} /></CriticalBadge>
        );
    }
    if (props.isReviewSoon) {
        return <CautionBadge><ChartExpiryText expiryDate={props.expiryDate}/></CautionBadge>;
    }
    
    return (
        <StandardBadge><ChartExpiryText expiryDate={props.expiryDate} /></StandardBadge>
    );
};

export const ChartExpiryText = (props: any) => {
    let spanStyle = {
        marginRight: '1px'
    }
    return <div><span style={spanStyle} >Chart expiry: </span><DateDisplay date={props.expiryDate} format={DateFormats.DDMMYYYY} isTextBold={false} /></div>
}
